var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-user",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M10.241,7.025a7.33,7.33,0,0,0-.838-.33,3.693,3.693,0,0,0,1.519-2.976,3.79,3.79,0,0,0-7.578,0A3.694,3.694,0,0,0,4.866,6.7a7.282,7.282,0,0,0-2.335,1.26A7.114,7.114,0,0,0,.037,12a1.638,1.638,0,0,0,.344,1.392A1.7,1.7,0,0,0,1.691,14H8.553a.547.547,0,1,0,0-1.094H1.691a.57.57,0,0,1-.446-.208.563.563,0,0,1-.118-.479A6.127,6.127,0,0,1,6.985,7.435l.148,0,.149,0a6.164,6.164,0,0,1,2.481.578.562.562,0,0,0,.742-.259A.542.542,0,0,0,10.241,7.025ZM7.268,6.34H7a2.65,2.65,0,0,1-2.54-2.622,2.675,2.675,0,0,1,5.349,0A2.65,2.65,0,0,1,7.268,6.34Z",
    transform: "translate(0)",
    fill: "#157af6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(9.126 9.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M326.362,323.924h-1.411v-1.411a.513.513,0,0,0-1.026,0v1.411h-1.411a.513.513,0,0,0,0,1.026h1.411v1.411a.513.513,0,1,0,1.026,0v-1.411h1.411a.513.513,0,1,0,0-1.026Z",
    transform: "translate(-322 -322)",
    fill: "#157af6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.039a7b70.svg";
export { ForwardRef as ReactComponent };